import { Api_EndPoints } from "AppQuries/utils/Api_EndPoints";
import { useMutation, useQuery } from "@tanstack/react-query";
import http_payroll from "AppQuries/utils/http_payroll";

const getCompanyDetails = async ({ isAll = false, companyCode }) => {
  if (!isAll && companyCode === 0) return [];

  const { data } = await http_payroll.get(
    `${Api_EndPoints.GetAllCompany}?isAll=${isAll}&CompanyCode=${companyCode}`,
  );
  return data;
};

const getCompanyListForClient = async ({ companyCode }) => {
  if (!companyCode) return [];
  const { data } = await http_payroll.get(
    `${Api_EndPoints.GetCompanyListforClient}?CompanyCode=${companyCode}`,
  );
  return data;
};

export const useGetCompanyQuery = (input) => {
  console.log("input", input);

  return useQuery({
    queryKey: [`${Api_EndPoints.GetAllCompany}-ID=${input.companyCode}`],
    queryFn: () => getCompanyDetails(input),
    refetchOnWindowFocus: false,
  });
};

const getCompany2 = async (input) => {
  const { data } = await http_payroll.post(Api_EndPoints.GetAllCompany, input);
  return data;
};

export const useGetCompanyMutation = () => {
  return useMutation({
    mutationFn: getCompany2,
  });
};

export const useGetCompanyListForClientQuery = (input) => {
  return useQuery({
    queryKey: [
      `${Api_EndPoints.GetAllCompany}-ID=${input.companyCode}-${new Date()}`,
    ],
    queryFn: () => getCompanyListForClient(input),
    refetchOnWindowFocus: false,
  });
};
